import z from "zod";
import RemoteCollection from "../../utility/remote-collection";

export const SymbolTypeListItem = z.object({
  id: z.number(),
  name: z.string().nullish(),
  code: z.string().nullish(),
});
export type SymbolTypeListItem = z.output<typeof SymbolTypeListItem>;
export const symbolTypeCollection = new RemoteCollection("/api/reference/admin/symbolType", SymbolTypeListItem);
export const ExchangeListItemSchema = z.object({
  id: z.number(),
  name: z.string(),
});
export const ExchangeDetailItemSchema = ExchangeListItemSchema.extend({
  delay: z.number().nullish(),
  updateType: z.string().nullish(),
  sessionStartTime: z.number().nullish(),
  chartStartTime: z.string().nullish(),
  chartEndTime: z.string().nullish(),
  timeZone: z.string().nullish(),
  tier: z.number().nullish(),
  popularity: z.number().nullish(),
  entitlementCode: z.string().nullish(),
  shortName: z.string().nullish(),
  prefixCode: z.string().nullish(),
  defaultCurrencyId: z.number().nullish(),
  domicileId: z.number().nullish(),
  defaultSymbolType: z.string().nullish(),
  flushHandler: z.string().nullish(),
  mic: z.string().nullish(),
  holidayGroup: z.string().nullish(),
  indexTags: z.array(z.string()).nullish(),
  searchPrefixes: z.array(z.string()).nullish(),
  searchSuffixes: z.array(z.string()).nullish(),
}).loose();
export type ExchangeListItem = z.output<typeof ExchangeListItemSchema>;
export type ExchangeDetailItem = z.output<typeof ExchangeDetailItemSchema>;
export const exchangeCollection = new RemoteCollection("/api/reference/admin/exchange", ExchangeListItemSchema, ExchangeDetailItemSchema);
export const DomicileListItemSchema = z.object({
  id: z.number(),
  name: z.string().nullish(),
  isoCode: z.string().nullish(),
});
export const DomicileDetailItemSchema = DomicileListItemSchema.extend({
  flag: z.string().nullish(),
  defaultCurrency: z.number().nullish(),
}).loose();
export type DomicileListItem = z.output<typeof DomicileListItemSchema>;
export type DomicileDetailItem = z.output<typeof DomicileDetailItemSchema>;
export const domicileCollection = new RemoteCollection("/api/reference/admin/domicile", DomicileListItemSchema, DomicileDetailItemSchema);
export const CorporateActionListItemSchema = z.object({
  id: z.number(),
  eventDate: z.string().nullish(),
  symbol: z.string().nullish(),
  source: z.string().nullish(),
  eventType: z.string().nullish(),
  value: z.number().nullish(),
});
export const CorporateActionDetailItemSchema = CorporateActionListItemSchema.loose(); // All Fields are in the list item schema
export type CorporateActionListItem = z.output<typeof CorporateActionListItemSchema>;
export type CorporateActionDetailItem = z.output<typeof CorporateActionDetailItemSchema>;
export const corporateActionCollection = new RemoteCollection(
  "/api/reference/admin/corporateAction",
  CorporateActionListItemSchema,
  CorporateActionDetailItemSchema,
);

//TODO: Add holiday group collection
export const HolidayListItemSchema = z.object({
  id: z.number(),
  holidayDate: z.string().nullish(),
  holidayGroup: z.string().nullish(),
  holidayName: z.string().nullish(),
});
export const HolidayDetailItemSchema = HolidayListItemSchema.loose(); // All Fields are in the list item schema
export type HolidayListItem = z.output<typeof HolidayListItemSchema>;
export type HolidayDetailItem = z.output<typeof HolidayDetailItemSchema>;
export const holidayCollection = new RemoteCollection("/api/reference/admin/holiday", HolidayListItemSchema, HolidayDetailItemSchema);

export const HolidayGroupListItemSchema = z.object({
  id: z.number(),
});

export const holidayGroupCollection = new RemoteCollection("/api/reference/admin/holiday/group", HolidayGroupListItemSchema);
export const CurrencyListItemsSchema = z.object({
  id: z.number(),
  name: z.string().nullish(),
  code: z.string().nullish(),
});
export const CurrencyDetailItemSchema = CurrencyListItemsSchema.extend({
  issuer: z.number().nullish(),
}).loose();
export type CurrencyListItem = z.infer<typeof CurrencyListItemsSchema>;
export type CurrencyDetailItem = z.infer<typeof CurrencyDetailItemSchema>;
export const currencyCollection = new RemoteCollection("/api/reference/admin/currency", CurrencyListItemsSchema, CurrencyDetailItemSchema);